"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function TabsOverflowMenu(props) {
    const { className, children } = props;
    return ((0, jsx_runtime_1.jsx)(OverflowScrollView, { className: className, children: children }));
}
exports.default = TabsOverflowMenu;
const OverflowScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  position: absolute;
  top: 100%;
  right: 0;

  flex-direction: column;

  box-sizing: border-box;
  width: 200px;
  max-height: 400px;

  background-color: ${props => props.theme.tabs.overflow.background};

  border: ${props => props.theme.tabs.overflow.border};
`;
